'use client'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/utils/cn'
import { HTMLAttributes, useRef } from 'react'
import StickyBox from 'react-sticky-box'
import { Policy } from './components/policy'
import { PopularProductList } from './components/popular-product-list'
import { ProductDetailFooter } from './components/product-detail-footer'
import { ProductDetailHeader } from './components/product-detail-header'
import { ProductDetailInfo } from './components/product-detail-info'
import { ProductDetailPriceHistory } from './components/product-detail-price-history'
import { ProductNotificationInfo } from './components/product-notification-info'
import { ProductThumbnail } from './components/product-thumbnail'
import { useProductDetailGA } from './hooks/use-product-detail-ga'
import { AlarmTooltipProvider } from './hooks/use-alarm-tooltip-show'
import { ReviewList } from './components/review-list'
import { ProductDetailPriceHistoriesProvider } from '@/shared/ui/history-chart-component/use-product-detail-price-histories'
import { useProductDetail } from './hooks/use-product-detail'

export interface ProductDetailProps extends HTMLAttributes<HTMLDivElement> {
  productId: string
}
/**
 *  상품 상세 페이지
 *  @link https://www.figma.com/design/FHDN0kenYCfJmkixvULIe5/%EB%82%B4%EC%9D%BC%EC%9D%80%EC%B5%9C%EC%A0%80%EA%B0%80?node-id=7546-50842
 */
export const ProductDetail = ({
  className,
  productId: id,
  ...props
}: ProductDetailProps) => {
  useProductDetailGA({ productId: id })
  const tooltipShowRef = useRef<HTMLDivElement>(null)
  const { isPending } = useProductDetail(id)

  return (
    !isPending && (
      <ProductDetailPriceHistoriesProvider
        defaultDuration={'6개월'}
        productId={id}
      >
        <AlarmTooltipProvider ref={tooltipShowRef}>
          <div className={cn(className)} {...props}>
            <StickyBox
              offsetTop={0}
              className="z-50 border-b border-b-gray-1 bg-white"
            >
              <ProductDetailHeader />
            </StickyBox>
            <main>
              <ProductThumbnail productId={id} />
              <Separator className="mb-5 h-2" />
              <ProductDetailInfo className="px-5" productId={id} />
              <Separator className="my-6 h-2" />
              <ProductDetailPriceHistory className="px-5" />
              <Separator className="my-5 h-2" />
              <ProductNotificationInfo productId={id} />
              <ReviewList className="px-5" productId={id} />
              <div ref={tooltipShowRef}>
                <Separator className="my-5 h-2" />
                <PopularProductList className="px-5" productId={id} />
                <Separator className="mt-5 h-2 bg-gray-2" />
                <Policy />
              </div>
            </main>
            <StickyBox className="bottom-0 z-50 w-full border-t border-t-gray-1 bg-white">
              <ProductDetailFooter productId={id} />
            </StickyBox>
          </div>
        </AlarmTooltipProvider>
      </ProductDetailPriceHistoriesProvider>
    )
  )
}
